<template>
  <div class="e-fence common-page">
    <m-title />
    <div class="e-fence-content">
      <div class="e-fence-content-top">
        <el-button @click="info = null, show_dlg = true" size="medium" type="primary"
          icon="el-icon-document">添加</el-button>
      </div>
      <div class="e-fence-content-inner">
        <el-table class='yh2-table' :cell-class-name="fn_cell_class_name" :data="fence_list" border fit height="100%">
          <template #empty>
            <el-empty />
          </template>
          <el-table-column v-for="it in table_fields" v-bind="it" :key="it.label" />
          <el-table-column label="操作" width="150px">
            <template #default="{ row }">
              <el-button type="text" @click="info = row, show_dlg = true">编辑</el-button>
              <el-button type="text" @click="fn_enable_fence(row)">{{ row.status == 0 ? '禁用' : '启用' }}</el-button>
              <el-button type="text" @click="fn_delete_fence(row)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="footer">
          <el-pagination prev-text="上一页" next-text="下一页" :current-page.sync="pagination.page" :total="pagination.total"
            @current-change="getData" :page-size="pagination.limit" layout="prev,pager,next,->,total" />
        </div>

      </div>
    </div>
    <map-fencing @success="pagination.page = 1, getData()" :show="show_dlg" :info="info" @close="info = null, show_dlg = false" />
    <!-- <fencingdemo @success="pagination.page = 1, getData()" :show="show_dlg" :info="info" @close="info = null, show_dlg = false" /> -->
  </div>
</template>

<script>
import mapFencing from './map-fencing.vue'
import fencingdemo from './fencingdemo.vue'
import mTitle from "@/components/mTitle";
import dayjs from 'dayjs'
import { MessageBox, Message } from 'element-ui'
export default {
  components: { mapFencing, mTitle,fencingdemo },

  data() {
    return {
      show_dlg: false,
      info: null,
      pagination: {
        limit: 20,
        page: 1,
        total: 0
      },
      fence_list: []
    }
  },
  computed: {
    table_fields() {
      return [
        { type: 'index', prop: 'index', label: "序号", width: 70 },
        { prop: 'electronicFenceName', label: '围栏名称' },
        {
          prop: 'fenceType', label: '类型',  formatter(_row, _col, val) {
            return val == 1 ? '途径点' : '电子围栏'
          }
        },
        {
          prop: 'shape', label: '围栏形状',  formatter(_row, _col, val) {
            if (val == "CIRCLE") {
              return '圆形'
            }
            if (val == 'POLYGON') {
              return '多边形'
            }
            return '-'

          }
        },
        {
          prop: 'status', label: '状态', formatter(_row, _col, val) {
            return ['启用', '禁用'][val] || val || '-'
          }
        },
        {
          prop: 'gmtCreate', label: '创建时间', width: 160, formatter(_row, _col, val) {
            return dayjs(val).format('YYYY-MM-DD HH:mm:ss')
          }
        },
        { prop: 'peopleCreate', label: '创建人' },
      ].map(it => ({
        formatter(_row, _col, val) {
          return val || '-'
        }, ...it
      }))
    }
  },
  created() {
    this.getData()
  },
  methods: {
    async fn_delete_fence(Row){
      await MessageBox.confirm(`是否要删除电子围栏 "${Row.electronicFenceName}"?`, '确认操作', { showClose: true, type: 'warning' })
      const res = await this.$http(
          'api1',
         '/electronicfence/fence/delete',
           'post',
          { ids:[Row.id] }
        )
        if (res.data.code != 0) {
          Message.error(res.data.msg)
          throw res.data
        }
        Message.success('操作成功')
        this.getData()
    },
    gomapfencing(){
      this.$router.push({
        path: '/home/fencingdemo',
        query: {
          info: this.info
        }
      })
    },
    fn_cell_class_name({ row, column }) {
      if (column.property == 'status') {
        if (row.status == 0) {
          return 'green'
        } else {
          return 'orange'
        }
      }

    },
    //启用禁用 围栏
    async fn_enable_fence(fence) {
      try {
        await MessageBox.confirm(`是否要${fence.status == 0 ? '禁用' : '启用'}电子围栏 "${fence.electronicFenceName}"?`, '确认操作', { showClose: true, type: 'warning' })
        const res = await this.$http(
          'api1',
         '/electronicfence/fence/update',
           'post',
          { ...fence, status: [1, 0][fence.status] }
        )
        if (res.data.code != 0) {
          Message.error(res.data.msg)
          throw res.data
        }
        Message.success('操作成功')
        this.getData()
      } catch (error) {
        console.log('error===>', error);
      }
    },
    async getData() {
      try {
        const { limit, page } = this.pagination
        const {data} = await this.$http(
          'api1',
           '/electronicfence/fence/list',
           'get',
          {
            limit,
            page
          }
        )
        this.fence_list = data.data.list
        // this.info=this.fence_list[1]
        this.pagination.total = data.data.totalCount

      } catch (error) {
        console.log("error", error)
        this.fence_list = []
        this.pagination.total = 0
      }
    }
  }

}
</script>

<style lang="scss">
.e-fence {
  height: 100%;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;

  .e-fence-content{
    background-color: #fff;
  }
  &-content {
    flex: 1;
    display: flex;
    flex-direction: column;
    overflow: hidden;


    &-top {
      padding: 10px 20px 8px;
      display: flex;
      justify-content: flex-start;

    }

    &-inner {
      padding: 0 20px 10px;
      flex: 1;
      box-sizing: border-box;
      display: flex;
      flex-direction: column;
    }

  }

}
</style>